/**
 * A way back. On a phone it is an arrow in a circle -- a 44px target a thumb
 * finds without reading -- and on a wide screen the arrow keeps its words
 * beside it. Its accessible name is always the words. (2026-10-13)
 */
export function BackButton({
  label,
  onClick,
  className,
}: {
  label: string;
  onClick: () => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      className={className ? `back-button ${className}` : 'back-button'}
      onClick={onClick}
      aria-label={label}
      title={label}
    >
      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
        <path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <span className="back-button-label" aria-hidden="true">{label}</span>
    </button>
  );
}
